export default {
    title: 'Vaša narudžbina je poslata!',
    message: {
        text1: 'Vaša naudžbina je poslata i trenutno se obrađuje.',
        text2: 'Status narudžbina možete pratiti u sekciji',
        myOrderSection: 'Moje narudžbine.'
    },
    orderOverview: 'Pregled narudžbine',
    payedOnline: 'Pregled računa plaćenog online',
    payedWithCash: 'Pregled računa koji plaćamo pouzećem',
    successful: 'uspješno',
    unsuccessful: 'neuspjelo',
    orderDate: 'Datum narudžbine',
    orderNumber: 'Broj narudžbine',
    paymentMethod: {
        title: 'Način plaćanja',
        cashOnDelivery: 'Pouzećem',
        creditCard: 'Kreditnom karticom'
    },
    transactionInfo: {
        title: 'Informacije o transakciji',
        status: 'Status',
        code: 'Šifra transakcije',
        payment: 'Plaćanje',
        authCode: 'Autorizacioni kod banke',
        date: 'Datum transakcije',
        atTheLatest: 'Okvirni datum isporuke:'
    },
    note: "Napomena",
    storePriceSummary: {
        sum: 'Suma',
        surcharge: 'Doplata',
        delivery: 'Dostava',
        total: 'Ukupno'
    },
    deliveryAddress: 'Adresa dostave',
    footer: {
        message: {
            sendYouEmail: 'Uskoro ćemo Vam poslati potvrdu narudžbine na email adresu.',
            thanksForBuying: 'Hvala Vam što trgujete na'
        },
        okButton: 'OK'
    },
    atTheLatest: 'najkasnije',
    transactionSuccessful: 'Transakcija je uspješno obavljena',
    tryAgain: 'Pokušaj ponovo',
    cardError: {
        code: 'Vaša transakcija nije odobrena. Molimo izaberite drugu karticu ili provjerite sa bankom koja Vam je izdala karticu.',
        code1000: 'Tehnički problem prilikom slanja zahtjeva. Molimo konkatirajte podršku.',
        code1001: 'Nestandardan odgovor banke. Molimo konkatirajte podršku.',
        code1002: 'Tehnički problem prilikom slanja zahtjeva. Molimo konkatirajte podršku.',
        code1003: 'Tehnički problem prilikom slanja zahtjeva. Molimo konkatirajte podršku.',
        code1004: 'Tehnički problem prilikom slanja zahtjeva. Molimo konkatirajte podršku.',
        code1005: 'Tehnički problem prilikom slanja zahtjeva. Molimo konkatirajte podršku.',
        code1006: 'Tehnički problem prilikom slanja zahtjeva. Molimo konkatirajte podršku.',
        code1007: 'Tehnički problem prilikom slanja zahtjeva. Molimo konkatirajte podršku.',
        code1008: 'Tehnički problem prilikom slanja zahtjeva. Molimo konkatirajte podršku.',
        code9999: 'Tehnički problem prilikom slanja zahtjeva. Molimo konkatirajte podršku.',
        code2001: 'Kartica koju ste unijeli ne može biti prihvaćena. Molimo pokušajte drugom karticom.',
        code2002: 'Transakcija je otkazana od strane kupca.',
        code2003: 'Vaša transakcija nije odobrena. Pokušajte ponovo ili promijenite karticu.',
        code2004: 'Kartica koju ste unijeli je premašila limit. Molimo izaberite drugu karticu.',
        code2005: 'Korisnik nije u predviđenom roku završio transakciju',
        code2006: 'Kartica koju ste unijeli je premašila limit. Molimo izaberite drugu karticu.',
        code2007: 'Unijeti podaci o platnoj kartici nisu tačni. Provjerite podatke i pokušajte ponovo.',
        code2008: 'Kartica koju ste unijeli ne može biti prihvaćena. Molimo pokušajte drugom karticom.',
        code2009: 'Kartica koju ste unijeli je istekla. Molimo izaberite drugu karticu.',
        code2010: 'Vaša transakcija nije odobrena. Molimo izaberite drugu karticu ili provjerite sa bankom koja Vam je izdala karticu.',
        code2011: 'Kartica koju ste unijeli ne može biti prihvaćena. Molimo pokušajte drugom karticom.',
        code2012: 'Transakcija je otkazana.',
        code2013: 'Vaša transakcija nije odobrena. Molimo izaberite drugu karticu ili provjerite sa bankom koja Vam je izdala karticu.',
        code2014: 'Vaša transakcija nije odobrena. Molimo izaberite drugu karticu ili provjerite sa bankom koja Vam je izdala karticu.',
        code2015: 'Vaša transakcija nije odobrena. Molimo izaberite drugu karticu ili provjerite sa bankom koja Vam je izdala karticu.',
        code2016: 'Vaša transakcija nije odobrena. Molimo izaberite drugu karticu ili provjerite sa bankom koja Vam je izdala karticu.',
        code2017: 'IBAN nije validan. Provjerite podatke i pokušajte ponovo.',
        code2018: 'BIC nije validan. Provjerite podatke i pokušajte ponovo.',
        code2019: 'Podaci o korisniku nisu validni. Provjerite podatke i pokušajte ponovo.',
        code2020: 'CVV kod je obavezan. Provjerite podatke i pokušajte ponovo',
        code2021: 'Vaša 3D Secure autentifikacija nije uspela. Molimo pozovite banku koja Vam je izdala karticu ili koristite karticu koja nije 3D-Secure.',
        code3001: 'Transakcija je istekla. Napravite pauzu i pokušajte nešto kasnije.',
        code3002: 'Transakcija nije dozvoljena.',
        code3003: 'Sistem privremeno nedostupan. Napravite pauzu i pokušajte nešto kasnije.',
        code3004: 'ID Transakcije mora već korišćen.',
        code3005: 'Transakcija nije odobrena usljed problema u komunikaciji sa bankom. Pokušajte ponovo nešto kasnije.',
        code7001: 'Zahtev za planiranjem transakcije nije validan.',
        code7002: 'Zahtev za planiranjem transakcije nije prihvaćen.',
        code7005: 'Planirana transakcija nije validna.',
        code7010: 'RegistrationId je neophodan.',
        code7020: 'RegistrationId nije validan.',
        code7030: 'RegistrationId nema odgovarajuću referencu.',
        code7035: 'Inicijalna transakcija kojom započinju planirana ponavljajuća plaćanja mora biti "register", "debit+register" ili "preauth+register".',
        code7036: 'Period između inicijalne i sljedeće transakcije mora biti duži od 24 sata.',
        code7040: 'ScheduleId (id planirane transakcije) nije validan ili nije povezan na ovaj kanal plaćanja.',
        code7050: 'Planirana početna transakcija nije validnog formata ili je starija od 24h.',
        code7060: 'Planirana naredna transakcija  nije validnog formata ili je starija od 24h.',
        code7070: 'Status planirane transakcije nije validnog formata za zahtijevanu operaciju.',
    }
}
